import Tabs, { ITab } from "@/components/Tabs";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const ShopSettingsController = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.endsWith("shop-settings")) navigate("privacy-details");
  }, [pathname]);

  const tabs: ITab[] = [
    {
      title: t("integrations.shopSettings.tabs.privacy"),
      path: "privacy-details",
      isVisible: true,
    },
    {
      title: t("integrations.shopSettings.tabs.disableCheckout"),
      path: "disable-checkout",
      isVisible: true,
    },
    {
      title: t("integrations.shopSettings.tabs.emailInstallation"),
      path: "installation",
      isVisible: true,
    },
    {
      title: t("integrations.shopSettings.tabs.preview"),
      path: "preview",
      isVisible: true,
    },
  ];

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          align="left"
          featureText={t("integrations.shopSettings.header.feature")}
          headingText={t("integrations.shopSettings.header.heading")}
        />
      </TypographyContainer>
      <div className="mt-2">
        <Tabs tabs={tabs} />
        <div className="mt-50">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ShopSettingsController;
